import React from "react";

const Like = props => {
  let classes = "fa fa-heart ";
  if (!props.liked) classes += "-o fa-lg";

 if (props.liked)  classes += " fa-lg text-danger";
  return (
    <i
      onClick={props.onClick}
      style={{ cursor: "pointer" }}
      className={classes}
      aria-hidden="true"
    />
  );
};

export default Like;



// WEBPACK FOOTER //
// ./src/components/common/like.jsx